import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import AppShell from "@/components/AppShell";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/", { replace: true });
    } else {
      setChecked(true);
    }
  }, [user, loading, navigate]);

  if (loading || !checked) {
    return (
      <div className="min-h-screen bg-[#F8F5EE] text-[#1A1F2C] flex items-center justify-center">
        <p className="font-serif text-2xl">Loading&hellip;</p>
      </div>
    );
  }

  return <AppShell>{children}</AppShell>;
}
